import { DELETE_SURVEY_ANSWER_T2, UPDATE_SURVEY_ANSWER_T2, SHOW_TIER_MODAL, UPDATE_CONTACTS, UPDATE_REASON, SHOW_BUSINESS_MODAL, UPDATE_ANSWERS, UPDATE_USER_INFO, UPDATE_SURVEY_ANSWERS, REMOVE_SURVEY_ANSWER, SET_SURVEY_RESPONSE, SET_TOTAL } from '../action/types'
import update from 'immutability-helper';


const initialState = {
    surveyResponse: {},
    userInfo: undefined,
    surveyAnswers: []
}

export default function surveyReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_ANSWERS:
            return update(state, {
                [action.payload.sectionKey]: {
                    answers: { $set: action.payload.answers }
                }
            });
        case SHOW_BUSINESS_MODAL:
            return update(state, {
                [action.payload.sectionKey]: {
                    showBM: { $set: action.payload.showBM }
                }
            });
        case SHOW_TIER_MODAL:
            return update(state, {
                tierShowModal: { $set: action.payload }
            });
        case UPDATE_CONTACTS:
            return update(state, {
                [action.payload.sectionKey]: {
                    contacts: { $set: action.payload.contacts }
                }
            });
        case UPDATE_REASON:
            return update(state, {
                [action.payload.sectionKey]: {
                    reason: { $set: action.payload.reason }
                }
            });
        case UPDATE_USER_INFO:
            return update(state, {
                userInfo: { $set: action.payload }
            });
        case UPDATE_SURVEY_ANSWER_T2:
            let newMapt2 = [...state.surveyAnswers];
            let questionIndext2 = newMapt2.findIndex(q => parseInt(q.questionId) === parseInt(parseInt(action.payload.questionId)) && parseInt(q.tierIndex) === parseInt(action.payload.tierIndex));
            if (questionIndext2 >= 0) {
                newMapt2[questionIndext2] = { ...newMapt2[questionIndext2], answer: action.payload.answer };
            } else {
                newMapt2.push({ questionId: parseInt(action.payload.questionId), answer: action.payload.answer, tierIndex: action.payload.tierIndex });
            }
            return update(state, {
                surveyAnswers: { $set: newMapt2 }
            })
        case UPDATE_SURVEY_ANSWERS:
            let newMap = [...state.surveyAnswers];
            let questionIndex = newMap.findIndex(q => parseInt(q.questionId) === parseInt(action.payload.questionId));
            if (questionIndex >= 0) {
                newMap[questionIndex] = { ...newMap[questionIndex], answer: action.payload.answer };
            } else {
                newMap.push({ questionId: parseInt(action.payload.questionId), answer: action.payload.answer });
            }
            return update(state, {
                surveyAnswers: { $set: newMap }
            })

        case DELETE_SURVEY_ANSWER_T2:
            let tierIdxTmp = parseInt(action.payload.tierIndex);
            let newMapp = [...state.surveyAnswers];
            newMapp = [...newMapp.filter(mapp => parseInt(mapp.tierIndex) !== tierIdxTmp)];
            newMapp.forEach(ans => {
                if(parseInt(ans.tierIndex) > tierIdxTmp){
                    ans.tierIndex = parseInt(ans.tierIndex) - 1;
                }
            });
            return update(state, {
                surveyAnswers: { $set: newMapp }
            })
        case REMOVE_SURVEY_ANSWER:
            let newResult = [...state.surveyAnswers];
            let idx = newResult.findIndex(q => parseInt(q.questionId) === parseInt(action.payload));

            if (idx >= 0) {
                newResult[idx] = { ...newResult[idx], answer: '' };
            }
            return update(state, {
                surveyAnswers: { $set: newResult }
            })
        case SET_SURVEY_RESPONSE:
            return {
                ...state,
                surveyResponse: action.payload,
                surveyAnswers: action.payload && action.payload.surveyAnswers ? action.payload.surveyAnswers : []
            }
        case SET_TOTAL:
            return {
                ...state,
                total: action.payload
            }

        default:
            return state
    }
}